import { type PropsWithChildren } from "react";
import { LayerContext } from "../contexts";

export interface LayerProviderProps extends PropsWithChildren {
  type: "content" | "excursion";
  slug?: string;
}

export const LayerProvider = ({ children, type, slug }: LayerProviderProps) => {
  return (
    <LayerContext.Provider value={{ type, slug }}>
      {children}
    </LayerContext.Provider>
  );
};
